module.exports = __webpack_public_path__ + "Loki-44573c54.png";